<template>
  <el-row class="footer">
    <slot></slot>
    <span style="display: inline-bolck;float:right;">
      <slot name="right"></slot>
    </span>
  </el-row>
</template>
<script>
export default {
  name: 'Footerbar',
  data() {
    return {};
  },

  methods: {}
};
</script>
<style lang="scss" scoped>
$navHeight: 60px;
.footer {
  height: $navHeight;
  line-height: $navHeight;
  background: #292929;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  text-align: left;
  padding-left: 40px;

  &-bind {
    color: #fff;
    padding-right: 5px;
  }
}
</style>